import { Injectable } from '@angular/core';
import {
  ChildPage,
  MainNavigationItem,
  SecondaryLinksSEO
} from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  checkStringValueNull,
  getSecondaryNavigationId,
  HeaderFooterMachCore,
  SecondaryNavigationAem
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import {
  MORE_NAV,
  SECONDARY_NAV,
  SKY_MILES_NAV
} from '../../constants/secondary-links/seconary-links.constants';

@Injectable({
  providedIn: 'root'
})
export class SecondaryNavigationLinksAdapterService {
  private secondaryNavItem: SecondaryNavigationAem;
  private footerInfoExternalImage: string;
  private footerExternalDescription: string;

  constructor() {
    this.secondaryNavItem = {} as SecondaryNavigationAem;
    this.footerInfoExternalImage = '';
    this.footerExternalDescription = '';
  }

  getContent(
    content: HeaderFooterMachCore,
    navigationId: string
  ): SecondaryLinksSEO {
    this.secondaryNavItem = this.checkSecondaryNavigation(
      content,
      navigationId
    );

    this.footerInfoExternalImage = content.footer?.info?.externalImgPath;
    this.footerExternalDescription = content.footer?.info?.footerExtDesc;

    return this.getNavigationContent(navigationId);
  }

  private getNavigationContent(navigationId: string): SecondaryLinksSEO {
    switch (navigationId) {
      case SECONDARY_NAV:
        return this.getSecondaryNavContent();
      case SKY_MILES_NAV:
        return this.getSkyMilesNavContent();
      case MORE_NAV:
        return this.getMoreNavContent();
      default:
        return {} as SecondaryLinksSEO;
    }
  }

  checkSecondaryNavigation(
    content: HeaderFooterMachCore,
    navigationId: string
  ): SecondaryNavigationAem {
    return (
      getSecondaryNavigationId(content, navigationId) ??
      ({} as SecondaryNavigationAem)
    );
  }

  getSecondaryNavContent(): SecondaryLinksSEO {
    return {
      id: checkStringValueNull(this.secondaryNavItem?.id),
      label: checkStringValueNull(this.secondaryNavItem?.label),
      pagePath: checkStringValueNull(this.secondaryNavItem?.pagePath),
      details: {
        mainNavigation: this.getMainNavigation(),
        childPages: this.getChildNavigation()
      },
      externalImgUrl: this.footerInfoExternalImage,
      externalImageDescription: this.footerExternalDescription
    };
  }

  getSkyMilesNavContent(): SecondaryLinksSEO {
    return {
      id: checkStringValueNull(this.secondaryNavItem?.id),
      label: checkStringValueNull(this.secondaryNavItem?.label),
      pagePath: checkStringValueNull(this.secondaryNavItem?.pagePath),
      details: {
        mainNavigation: this.getMainNavigation(),
        childPages: this.getChildNavigation()
      },
      externalImgUrl: this.footerInfoExternalImage,
      externalImageDescription: this.footerExternalDescription
    };
  }

  getMoreNavContent(): SecondaryLinksSEO {
    return {
      id: checkStringValueNull(this.secondaryNavItem?.id),
      label: checkStringValueNull(this.secondaryNavItem?.label),
      pagePath: checkStringValueNull(this.secondaryNavItem?.pagePath),
      details: {
        mainNavigation: this.getMainNavigation(),
        childPages: this.getChildNavigation()
      },
      externalImgUrl: this.footerInfoExternalImage,
      externalImageDescription: this.footerExternalDescription
    };
  }

  getMainNavigation(): MainNavigationItem[] {
    return this.secondaryNavItem.details.mainNavigation.map((item) => {
      return {
        brandLabel: item.brandLabel,
        targetUrl: item.targetUrl,
        imagePathDesktop: item.svgPathDesktop ?? '',
        openInNewTab: item.openinnewTab === 'false' ? false : true,
        externalImage: item.externalimage === 'false' ? false : true,
        altText: item.altText
      };
    });
  }

  getChildNavigation(): ChildPage[] {
    return this.secondaryNavItem.details.childPages.map((item) => {
      return {
        pageName: item.pageName,
        pageUrl: item.pageUrl,
        openInNewTab: item.openinnewTab === 'false' ? false : true,
        externalImage: item.externalimage === 'false' ? false : true
      };
    });
  }
}
